import { render, staticRenderFns } from "./costPerSector.vue?vue&type=template&id=0bdd1677&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./costPerSector.vue?vue&type=style&index=0&id=0bdd1677&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdd1677",
  null
  
)

export default component.exports